(() => {
  const GIFT_HANDLE = 'usborne-wind-up-ladybird-carte-cu-jucarie-pentru-copii-3-ani';
  const THRESHOLD = 29900; // 299 lei
  const CAMPAIGN_MATCH = '208062185816';
  const CART_ATTR_KEY = 'promo_joy_de_joi_newsletter';
  const root = window.Shopify?.routes?.root || '/';

  let isRunning = false;
  let giftVariantId = null;

  function getUrl() {
    return new URL(window.location.href);
  }

  function cameFromThisNewsletter() {
    const url = getUrl();
    const source = (url.searchParams.get('utm_source') || '').toLowerCase();
    const medium = (url.searchParams.get('utm_medium') || '').toLowerCase();
    const campaign = url.searchParams.get('utm_campaign') || '';

    return (
      source === 'shopify_email' &&
      medium === 'email' &&
      campaign.includes(CAMPAIGN_MATCH)
    );
  }

  async function getGiftVariantId() {
    if (giftVariantId) return giftVariantId;

    const res = await fetch(`${root}products/${GIFT_HANDLE}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Nu am putut lua produsul cadou');
    }

    const product = await res.json();
    const variant = product.variants.find(v => v.available) || product.variants[0];

    if (!variant || !variant.id) {
      throw new Error('Nu am gasit o varianta valida pentru cadou');
    }

    giftVariantId = variant.id;
    return giftVariantId;
  }

  async function getCart() {
    const res = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Nu am putut citi cosul');
    }

    return await res.json();
  }

  async function setPromoCartAttribute() {
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [CART_ATTR_KEY]: '1'
        }
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Nu am putut seta atributul de promo: ${res.status} ${text}`);
    }

    return await res.json();
  }

  function isPromoActive(cart) {
    const attrs = cart.attributes || {};
    return String(attrs[CART_ATTR_KEY] || '') === '1';
  }

  function subtotalWithoutAutoGift(cart) {
    return cart.items.reduce((sum, item) => {
      const isAutoGift = item.properties && item.properties._auto_gift === 'true';
      if (isAutoGift) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function findAutoGiftLineIndex(cart, currentGiftVariantId) {
    return cart.items.findIndex(item => {
      const isSameVariant = item.variant_id === currentGiftVariantId;
      const isAutoGift = item.properties && item.properties._auto_gift === 'true';
      return isSameVariant && isAutoGift;
    });
  }

  async function addGift(currentGiftVariantId) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: currentGiftVariantId,
            quantity: 1,
            properties: {
              _auto_gift: 'true',
              _campaign: 'EASTER_NEWSLETTER'
            }
          }
        ]
      })
    });

    const text = await res.text();

    if (!res.ok) {
      throw new Error(`Add gift failed: ${res.status} ${text}`);
    }

    return text;
  }

  async function removeLine(line) {
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity: 0
      })
    });

    const text = await res.text();

    if (!res.ok) {
      throw new Error(`Remove line failed: ${res.status} ${text}`);
    }

    return text;
  }

  async function setLineQuantity(line, quantity) {
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    });

    const text = await res.text();

    if (!res.ok) {
      throw new Error(`Set line quantity failed: ${res.status} ${text}`);
    }

    return text;
  }

  function refreshVisibleCart() {
    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));

    setTimeout(() => {
      const bubble = document.querySelector('#cart-icon-bubble, .cart-count-bubble');
      if (bubble) {
        bubble.classList.add('is-updating');
        setTimeout(() => bubble.classList.remove('is-updating'), 200);
      }
    }, 50);
  }

  async function syncGift() {
    if (isRunning) return;
    isRunning = true;

    try {
      if (cameFromThisNewsletter()) {
        await setPromoCartAttribute();
      }

      const currentGiftVariantId = await getGiftVariantId();
      const cart = await getCart();

      const promoActive = isPromoActive(cart);
      const autoGiftIndex = findAutoGiftLineIndex(cart, currentGiftVariantId);
      const hasAutoGift = autoGiftIndex !== -1;
      const autoGiftItem = hasAutoGift ? cart.items[autoGiftIndex] : null;
      const subtotal = subtotalWithoutAutoGift(cart);

      // Daca promo NU e activ, stergem doar giftul auto-adaugat.
      // Produsul adaugat manual ramane in cos.
      if (!promoActive) {
        if (hasAutoGift) {
          await removeLine(autoGiftIndex + 1);
          refreshVisibleCart();
        }
        return;
      }

      // Giftul promo nu poate depasi 1 bucata
      if (hasAutoGift && autoGiftItem.quantity > 1) {
        await setLineQuantity(autoGiftIndex + 1, 1);
        refreshVisibleCart();
        return;
      }

      // Adaugam giftul doar pentru cosurile eligibile din promo
      if (subtotal >= THRESHOLD && !hasAutoGift) {
        await addGift(currentGiftVariantId);
        refreshVisibleCart();
        return;
      }

      // Scoatem doar giftul auto-adaugat daca scade sub prag
      if (subtotal < THRESHOLD && hasAutoGift) {
        await removeLine(autoGiftIndex + 1);
        refreshVisibleCart();
        return;
      }
    } catch (err) {
      console.error('FREE GIFT ERROR:', err);
    } finally {
      isRunning = false;
    }
  }

  function bindTriggers() {
    syncGift();

    document.body.addEventListener('submit', (event) => {
      const form = event.target;
      if (form && form.matches('form[action*="/cart/add"]')) {
        setTimeout(syncGift, 900);
      }
    });

    document.body.addEventListener('click', (event) => {
      const el = event.target.closest(
        'button[name="add"], .add-to-cart, [data-add-to-cart], .quantity__button, .cart-remove, [name="update"]'
      );

      if (el) {
        setTimeout(syncGift, 900);
      }
    });

    window.addEventListener('focus', () => {
      setTimeout(syncGift, 300);
    });

    document.addEventListener('cart:updated', () => {
      setTimeout(syncGift, 300);
    });
  }

  document.addEventListener('DOMContentLoaded', bindTriggers);
})();